

export default {
    env:"dev", 
    logging: true,
    baseURL: '/api',
    timerAlertCountdown: '120',
    Crypto: {
        ECDH: {
            PublicKeyB:
                'BAD1Fc9PG29SdYLnwP1qb3Tl8J+NAB2+XcofH3sUKqL/amZ7c1mXZINJkVJY+ifm93N+FV9N/mPmzTUacOXlXvn1NgHYRq3s00mrD6mNToJOM5MXSDdHdSwFeoIsOfA7FGU1ICce1lYQ4MeHoCiv0TJHm4iCYVLahOe8jXtrm+5NAaFfqQ=='
        }
    },
    fileUrl:"/api/file/",
    publicFileUrl:"api/file/public/",
    publicBroadcastUrl:"/api/broadcast/",
    feedPortalUrl:"https://md1-pcsb.finext.com.my",//uat
   // feedPortalUrl:"https://md1-philipcap.finext.com.my",//sit
    headerLogo:"/img/PhillipXW.png",
    signUpUrl:"https://www.philliptrade.com.my/aibbecos/signup.asp",
    contactUsUrl:"https://www.phillip.com.my/contact-us/",
    recaptchaSiteKey:"",
    enableChangeTradingPin: 1, //1 = show change/reset trading pin options

    traderPinForceNumeric: 0, //optional, 1 = trading pin only allows numbers regardless of admin rules

    hideSecretAnswer: { //1 = hide secret answer
        registerAccount: 1,     // /register-account questions
        firstTimeLogin: 1,      // /first-time-login questions
        changeSecretAnswer: 1   // "Change Secret Answer" tab
    }
};

